import React from 'react'
import { Column } from 'primereact/column'
import InputTextEditor from './InputTextEditor'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

const TextColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, template, originalData, style, className, filterElement, filterMatchMode }) => {

    const filterAttributes = filterElement ? {
        filter: true,
        filterElement,
        filterMatchMode,
        showFilterMatchModes: false
    } : {
        filter,
        filterPlaceholder: `Search by  ${title}`,
        required: !!filter,
        disabled: !filter
    }
    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    // Create smart field changed checker
    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}            
            style={style}
            className={className}
            body={(rowData) => (
                <span className={`${checkFieldChanged(rowData) ? 'changed-field' : ''} ${rowData.isDeleted ? 'pending-deletion' : ''}`}>
                    {template ? template(rowData) : rowData[mapsToField]}
                </span>
            )}
            editor={editable ? (options) => <InputTextEditor options={options} validationErrors={validationErrors} /> : null}
            {...filterAttributes}/>
    )
}

export default TextColumn
